"use strict";
var $ = require("../internals/export");
var $filter = require("../internals/array-iteration").filter;
var arrayMethodHasSpeciesSupport = require("../internals/array-method-has-species-support");
var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport("filter");
$({ target: "Array", proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  filter: function filter(callbackfn) {
    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : void 0);
  }
});
